import { grayPaletteDark } from '../../../themes/dark-colors';

export const searchDarkTheme = {
  clearIndicatorColor: grayPaletteDark[800],
  backgroundColor: grayPaletteDark[0],
};
